import {FunctionComponent, PropsWithChildren} from 'react';
import styles from './styles.module.scss';

const FormError: FunctionComponent<PropsWithChildren<{}>> = ({children}) => {
  return <div className={`${styles.error}`}>{children}</div>;
};

export default FormError;
